import { use } from 'react';

import { AdminContext } from './admin-context';

export function useAdmin() {
  return use(AdminContext);
}
